import React, { useEffect } from 'react';

import * as echarts from 'echarts';

export const PieChart = ({ id, width, height }) => {
  useEffect(() => {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom, null, {
      width,
      height,
    });
    var option;

    option = {
      tooltip : {
        trigger : 'item',
      },
      legend : {
        show   : true,
        orient : 'horizontal',
        bottom : '0%',
        icon   : 'circle',
        width  : '80%',
      },
      series : [
        {
          name  : 'Access From',
          label : {
            show : false,
          },
          top       : '-30%',
          itemStyle : {
            borderRadius : 0,
            borderColor  : '#fff',
            borderWidth  : 2,
          },
          type : 'pie',
          data : [
            {
              value     : 20,
              name      : '20-29',
              itemStyle : {
                color : '#BABABA',
              },
            },
            {
              value     : 30,
              name      : '30-39',
              itemStyle : {
                color : '#00778B',
              },
            },
            {
              value     : 40,
              name      : '40-49',
              itemStyle : {
                color : '#BABABA',
              },
            },
            {
              value     : 50,
              name      : '50-59',
              itemStyle : {
                color : '#BABABA',
              },
            },
            {
              value     : 60,
              name      : '60-69',
              itemStyle : {
                color : '#BABABA',
              },
            },
            {
              value     : 70,
              name      : '70-79',
              itemStyle : {
                color : '#BABABA',
              },
            },
          ],
        },
      ],
    };

    option && myChart.setOption(option);
    // eslint-disable-next-line
  }, []);

  return <div
    id={id}
  />;
};
